import React, { ReactElement } from 'react';
import DividerInternal from '@mui/material/Divider';
import FormatService from '../../services/format-service';
import useStylesDivider from './divider.styles';

const Divider: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isLight,
    withOffset,
  } = props;

  const { classes } = useStylesDivider();

  const lightClassName: string | undefined = isLight ? classes.dividerLight : undefined;
  const offsetClassName: string | undefined = withOffset ? classes.dividerOffset : undefined;

  return (
    <DividerInternal className={FormatService.formatClassNames(lightClassName, offsetClassName)} />
  );
});

export default Divider;
